import { html, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import EkoElement from "@/utilities/element";
import style from "./stack.css?inline";

@customElement("eko-stack")
export class Stack extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property({ reflect: true, attribute: "align-items" })
  alignItems: "start" | "center" | "end" | "baseline" | "stretch" = "stretch";

  @property({ reflect: true })
  direction: "horizontal" | "vertical" = "vertical";

  @property({ reflect: true })
  gap: "none" | "xs" | "sm" | "md" | "lg" | "xl" | "2xl" = "md";

  @property({ reflect: true, attribute: "justify-content" })
  justifyContent: "start" | "center" | "end" | "space-between" | "space-around" | "space-evenly" =
    "start";

  @property({ reflect: true, type: Boolean })
  reverse: boolean = false;

  @property({ reflect: true, type: Boolean })
  wrap: boolean = false;

  render() {
    return html` <slot></slot> `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-stack": Stack;
  }
}
